import lz from "lzutf8";

export function decodeBase64ToUtf8(data: string): string {
  return lz.decodeUTF8(lz.decodeBase64(data));
}

export async function decompressFromBase64(data: string): Promise<string> {
  return lz.decompress(data, { inputEncoding: "Base64", outputEncoding: "String" }) as string;
}
